export const buildWhatsappUrl = (phoneNumber: string, message?: string | null) => {
  const digits = phoneNumber.replace(/\D/g, "");
  const baseUrl = `https://wa.me/${digits}`;

  if (!message || message.trim().length === 0) {
    return baseUrl;
  }

  const encodedMessage = encodeURIComponent(message.trim());
  return `${baseUrl}?text=${encodedMessage}`;
};

